import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Button, Grid } from "@mui/material";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SiteMap from "../components/SiteMap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function EditData({ isEditing }) {
    const navigate = useNavigate();

    const [width, setWidth] = useState(window.innerWidth);

    const [name, setName] = useState("");
    const [sex, setSex] = useState("");
    const [etnicity, setEtnicity] = useState("");
    const [birthday, setBirthday] = useState(new Date());

    const [disability, setDisability] = useState("Sim");
    const [disabilityType, setDisabilityType] = useState("");

    const [address, setAddress] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [cep, setCep] = useState("");
    const [neighboor, setNeighboor] = useState("");
    const [city, setCity] = useState("");
    const [phone, setPhone] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [email, setEmail] = useState("");
    const [rg, setRg] = useState("");
    const [cpf, setCpf] = useState("");
    const [scholarity, setScholarity] = useState("");
    const [civilState, setCivilState] = useState("");

    const [rf, setRf] = useState("");
    const [secretary, setSecretary] = useState("");
    const [work, setWork] = useState("");
    const [department, setDepartment] = useState("");
    const [sector, setSector] = useState("");
    const [turn, setTurn] = useState("");
    const [workFunction, setWorkFunction] = useState("");
    const [filliationDate, setFilliationDate] = useState(new Date());
    const [admissionDate, setAdmissionDate] = useState(new Date());
    const [unityCode, setUnityCode] = useState("");
    const [unityEmail, setUnityEmail] = useState("");
    const [unityPhone, setUnityPhone] = useState("");

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    async function sendMail() {
        const data = {
            name,
            sex,
            etnicity,
            birthday,
            disability,
            disabilityType,
            address,
            number,
            complement,
            cep,
            neighboor,
            city,
            phone,
            cellphone,
            email,
            rg,
            cpf,
            scholarity,
            civilState,
            rf,
            secretary,
            work,
            department,
            sector,
            turn,
            workFunction,
            filliationDate,
            admissionDate,
            unityCode,
            unityEmail,
            unityPhone
        };

        await axios.post(
            `https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production/update-infos`,
            data,
            {
                headers: {
                    "Content-Type": "application/json;charset=utf-8",
                },
                crossDomain: true,
            }
        );

        alert("Dados enviados com sucesso!")
        navigate(`/`)
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;
    const fieldStyle = {
        backgroundColor: isEditing ? "#FFFFFF" : "#EAECF0",
    };

    const InputField = ({ id, label, type = "text", value, onChange, name, options }) => (
        <div className="edit-data-field" style={{ width: "100%" }}>
            <label htmlFor={id}>{label}</label>
            {options ? (
                <select id={id} value={value} onChange={onChange} name={name} style={fieldStyle}>
                    <option value="">Selecione</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            ) : (
                <input id={id} type={type} value={value} onChange={onChange} name={name} style={fieldStyle} />
            )}
        </div>
    );

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Editar Dados</h1>
                <Grid
                backgroundColor={!isEditing ? "#FFFFFF" : "#EAECF0"}
                borderRadius={2}
                paddingBottom={8}
                marginTop={4}
                paddingX={isEditing || isMobile ? 4 : 48}
                gap={2}
                rowGap={2}
                container
            >
                <Grid xs={12} md={11.12} marginTop={2}>
                    <Typography
                        color={"#C81E1E"}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="600"
                        fontSize="22px"
                        lineHeight="18px"
                        marginLeft={1}
                    >
                        Atualize seu cadastro
                    </Typography>
                </Grid>
                <Grid xs={12} md={11.12} marginTop={4}>
                    <Typography
                        color={"#202020"}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="500"
                        fontSize="18px"
                        lineHeight="18px"
                        marginLeft={1}
                    >
                        Dados Pessoais
                    </Typography>
                </Grid>
                <Grid xs={12} md={11.12} marginTop={2}>
                    <InputField id="name" label="Nome/Nome Social" value={name} onChange={(e) => setName(e.target.value)} name="name" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="birthday" label="Data de nascimento" type="date" value={birthday instanceof Date ? birthday.toISOString().slice(0, 10) : birthday} onChange={(e) => setBirthday(e.target.value)} name="birthday" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="sex" label="Sexo" value={sex} onChange={(e) => setSex(e.target.value)} name="sex" options={[
                        { value: "Masculino", label: "Masculino" },
                        { value: "Feminino", label: "Feminino" },
                    ]} />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="etnicity" label="Raça/Etnia" value={etnicity} onChange={(e) => setEtnicity(e.target.value)} name="etnicity" options={[
                        { value: "Branco", label: "Branco" },
                        { value: "Preto", label: "Preto" },
                        { value: "Pardo", label: "Pardo" },
                        { value: "Amarelo", label: "Amarelo" },
                        { value: "Indígena", label: "Indígena" },
                        { value: "Não Declarar", label: "Não Declarar" },
                    ]} />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <fieldset className="edit-data-fieldset" style={fieldStyle}>
                        <legend>Possui alguma deficiência?</legend>
                        <div className="edit-data-radio-group">
                            <label>
                                <input type="radio" name="disability" value="Sim" checked={disability === "Sim"} onChange={(e) => setDisability(e.target.value)} />
                                Sim
                            </label>
                            <label>
                                <input type="radio" name="disability" value="Não" checked={disability === "Não"} onChange={(e) => setDisability(e.target.value)} />
                                Não
                            </label>
                        </div>
                    </fieldset>
                </Grid>
                {disability === "Sim" && (
                    <Grid xs={12} md={5.5}>
                        <InputField id="disabilityType" label="Se sim, qual?" value={disabilityType} onChange={(e) => setDisabilityType(e.target.value)} name="disability" />
                    </Grid>
                )}
                <Grid xs={12} md={11.12}>
                    <InputField id="address" label="Endereço" value={address} onChange={(e) => setAddress(e.target.value)} name="address" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="cep" label="CEP" type="number" value={cep} onChange={(e) => setCep(e.target.value)} name="cep" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="neighboor" label="Bairro" value={neighboor} onChange={(e) => setNeighboor(e.target.value)} name="neighboor" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="number" label="Número" type="number" value={number} onChange={(e) => setNumber(e.target.value)} name="number" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="complement" label="Complemento" value={complement} onChange={(e) => setComplement(e.target.value)} name="complement" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="city" label="Cidade" value={city} onChange={(e) => setCity(e.target.value)} name="city" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="phone" label="Telefone" value={phone} onChange={(e) => setPhone(e.target.value)} name="phone" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="cellphone" label="Celular" type="tel" value={cellphone} onChange={(e) => setCellphone(e.target.value)} name="cellphone" />
                </Grid>
                <Grid xs={12} md={11.12}>
                    <InputField id="email" label="E-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="email" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="cpf" label="CPF" type="number" value={cpf} onChange={(e) => setCpf(e.target.value)} name="cpf" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="rg" label="RG" type="number" value={rg} onChange={(e) => setRg(e.target.value)} name="rg" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="civilState" label="Estado civil" value={civilState} onChange={(e) => setCivilState(e.target.value)} name="civilState" options={[
                        { value: "Solteiro (a)", label: "Solteiro (a)" },
                        { value: "Casado (a)", label: "Casado (a)" },
                        { value: "Separado (a)", label: "Separado (a)" },
                        { value: "Divorciado (a)", label: "Divorciado (a)" },
                        { value: "Viúvo (a)", label: "Viúvo (a)" },
                        { value: "Outro", label: "Outro" },
                    ]} />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="scholarity" label="Escolaridade" value={scholarity} onChange={(e) => setScholarity(e.target.value)} name="scholarity" options={[
                        { value: "Graduação", label: "Graduação" },
                        { value: "Pós-Graduação", label: "Pós-Graduação" },
                        { value: "MBA", label: "MBA" },
                        { value: "Mestrado", label: "Mestrado" },
                        { value: "Doutorado", label: "Doutorado" },
                        { value: "Pós-Doutorado", label: "Pós-Doutorado" },
                        { value: "Livre Docência", label: "Livre Docência" },
                        { value: "Técnico", label: "Técnico" },
                        { value: "Ens. Fundamental Completo", label: "Ens. Fundamental Completo" },
                        { value: "Ens. Médio Completo", label: "Ens. Médio Completo" },
                        { value: "Outro", label: "Outro" },
                    ]} />
                </Grid>
                <Grid xs={12} md={11.12} marginTop={4}>
                    <Typography
                        color={"#202020"}
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="500"
                        fontSize="18px"
                        lineHeight="18px"
                        marginLeft={1}
                    >
                        Dados Profissionais
                    </Typography>
                </Grid>
                <Grid xs={12} md={11.12} marginTop={4}>
                    <InputField id="rf" label="RF (Registro Funcional)" type="number" value={rf} onChange={(e) => setRf(e.target.value)} name="funtionalRegister" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="secretary" label="Secretaria" value={secretary} onChange={(e) => setSecretary(e.target.value)} name="secretary" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="work" label="Unidade de trabalho" value={work} onChange={(e) => setWork(e.target.value)} name="workLocal" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="department" label="Departamento" value={department} onChange={(e) => setDepartment(e.target.value)} name="department" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="sector" label="Setor" value={sector} onChange={(e) => setSector(e.target.value)} name="sector" />
                </Grid>
                <Grid xs={12} md={3.6}>
                    <InputField id="turn" label="Turno" value={turn} onChange={(e) => setTurn(e.target.value)} name="turn" />
                </Grid>
                <Grid xs={12} md={11.12}>
                    <InputField id="workFunction" label="Cargo/Função" value={workFunction} onChange={(e) => setWorkFunction(e.target.value)} name="function" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="filliationDate" label="Data de Filiação" type="date" value={filliationDate instanceof Date ? filliationDate.toISOString().slice(0, 10) : filliationDate} onChange={(e) => setFilliationDate(e.target.value)} name="filliationDate" />
                </Grid>
                <Grid xs={12} md={5.5}>
                    <InputField id="admissionDate" label="Data de admissão" type="date" value={admissionDate instanceof Date ? admissionDate.toISOString().slice(0, 10) : admissionDate} onChange={(e) => setAdmissionDate(e.target.value)} name="admissionDate" />
                </Grid>
                <Grid xs={12} md={11.12} marginTop={2}>
                    <InputField id="unityCode" label="Código do Endereçamento da Unidade" value={unityCode} onChange={(e) => setUnityCode(e.target.value)} name="unityCode" />
                </Grid>
                <Grid xs={12} md={11.12} marginTop={2}>
                    <InputField id="unityEmail" label="Email da Unidade" value={unityEmail} onChange={(e) => setUnityEmail(e.target.value)} name="unityEmail" />
                </Grid>
                <Grid xs={12} md={11.12} marginTop={2}>
                    <InputField id="unityPhone" label="Telefone da Unidade" value={unityPhone} onChange={(e) => setUnityPhone(e.target.value)} name="unityPhone" />
                </Grid>
                <Grid xs={12} md={5.5}></Grid>
                <Grid xs={12} md={5.5}>
                    <Button
                        fullWidth
                        style={{
                            borderRadius: 32,
                            marginTop: 32,
                            textAlign: "center",
                            backgroundColor: "#C81E1E",
                        }}
                        onClick={sendMail}
                    >
                        <Typography
                            color="#FFFFFF"
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="600"
                            fontSize="16px"
                            lineHeight="20px"
                            padding={2}
                        >
                            ATUALIZAR CADASTRO
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
}

export default EditData;
